import { render, staticRenderFns } from "./RevenueSourcesList.vue?vue&type=template&id=1bc5a668&scoped=true&"
import script from "./RevenueSourcesList.vue?vue&type=script&lang=js&"
export * from "./RevenueSourcesList.vue?vue&type=script&lang=js&"
import style0 from "./RevenueSourcesList.vue?vue&type=style&index=0&id=1bc5a668&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc5a668",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
